import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import translationEN from "src/locales/en/translation.json";
import translationKR from "src/locales/kr/translation.json";

const resources = {
  en: {
    translation: translationEN,
  },
  ko: {
    translation: translationKR,
  },
  kr: {
    translation: translationKR,
  },
};

i18n.use(initReactI18next).init({
  resources,
  lng: "en",
  fallbackLng: ["ko", "kr", "en"],
  interpolation: {
    escapeValue: false,
  },
});

export default i18n;
